<div class="a-titulo">
    MANTENIMIENTO CUOTA EJECUTIVO
</div>
<div class="a-w1-column">
    <form [formGroup]="group" class="a-w1-row">
        <div class="a-w2 a-w1-row">
            <p-floatLabel class="w-full md:w-56" variant="on">
                <p-calendar class="a-w1" formControlName="desde" [dateFormat]="'dd/mm/yy'" styleClass="w-full md:w-56"></p-calendar>
                <label htmlFor="username" for="on_label">Fecha Desde</label>
            </p-floatLabel>
            <p-floatLabel class="w-full md:w-56" variant="on">
                <p-calendar class="a-w1" formControlName="hasta" [dateFormat]="'dd/mm/yy'" styleClass="w-full md:w-56"></p-calendar>
                <label htmlFor="username" for="on_label">Fecha Hasta</label>
            </p-floatLabel>
            <p-floatLabel class="w-full md:w-56" variant="on">
                <input type=" text" pInputText class="w-full md:w-56" formControlName="periodo">
                <label htmlFor="username" for="on_label">Periodo</label>
            </p-floatLabel>
        </div>
        <div class="a-w2 a-w1-row" style="gap: 20px;">
            <p-button icon="pi pi-search" label="Buscar" severity="info" (onClick)="search()"></p-button>
            <p-button icon="pi pi-plus" label="Nuevo" severity="info" (onClick)="nuevo()"></p-button>
            <p-button icon="pi pi-file-import" label="Importar" severity="info" (onClick)="importExcel()"></p-button>
            <p-button icon="pi pi-sign-out" label="Salir" severity="info" (onClick)="salirBandejaPrincipal()"></p-button>
        </div>
    </form>
    <app-datatable [metadataTable]="cuotaEjecutivoMDT" [dataTable]="dataTable">
        <ng-template #addHeaderStart>
            <th class="header">
                <div class="items-header">
                    <span>Acción</span>
                </div>
            </th>
        </ng-template>
        <ng-template #addBodyStart let-row="row">
            <td class="a-datatable-datos-body-accion row-space">
                <p-button icon="pi pi-pencil" severity="info" styleClass="p-button-rounded p-button-outlined"
                    (onClick)="edit('',row)" pTooltip="Editar" tooltipPosition="top"></p-button>
            </td>
        </ng-template>
    </app-datatable>
</div>
<p-dialog header="" [(visible)]="visible" [style]="{width: '60vw',height: '100vh'}" appendTo="body">
    <br>
    <form [formGroup]="groupPoppup2" class="a-w1" style="margin: 0;">
        <div class="a-w1-row">
            <div class="a-w2">
                <p-floatLabel class="w-full md:w-56" variant="on">
                    <p-select formControlName="anio" [readonly]="!visiblebtn" [options]="listAnio"
                        [filter]="true" class="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Año</label>
                </p-floatLabel>
            </div>
            <div class="a-w2">
                <p-floatLabel class="w-full md:w-56" variant="on">
                    <p-select formControlName="mes" [readonly]="!visiblebtn" [options]="listMes"
                        inputId="float-label" [filter]="true" class="w-full md:w-56">
                    </p-select>
                    <label for="on_label">Mes</label>
                </p-floatLabel>
            </div>
        </div>
        <div class="a-w1-row" style="padding-top: 20px;">
            <div class="a-w1">
                <p-floatLabel class="w-full md:w-56" variant="on">
                    <input type="text" formControlName="descripcion" pInputText class="w-full md:w-56"/>
                    <label for="on_label">Descripción</label>
                </p-floatLabel>
            </div>
        </div>

    </form>
    <div style="justify-content: center; display: flex; gap: 20px; padding-top: 8px;">
        <p-button *ngIf="visiblebtn" label="Guardar" severity="info" (onClick)="TransaccionCuotas('I')"></p-button>
        <p-button *ngIf="!visiblebtn" label="Actualizar" severity="info" (onClick)="TransaccionCuotas('U')"></p-button>
        <p-button label="Salir" severity="info" (onClick)="salir()"></p-button>
    </div>
    <div class="a-w1-row" style="padding-top: 8px;">
        <form [formGroup]="groupPoppup2" class="a-w1">
            <p-table [value]="dataTablePoppup" [tableStyle]="{ 'width': '100%', 'font-size': '10px', }">
                <ng-template pTemplate="header" style="height: 20px;">
                    <tr>
                        <th style="width:13%; text-align: center;">COD. EJECUTIVO</th>
                        <th style="width:27%; text-align: center;">NOM. EJECUTIVO</th>
                        <th style="width:15%; text-align: center;">CUOTA</th>
                        <th style="width:15%; text-align: center;">EXPORTACIONES</th>
                        <th style="width:15%; text-align: center;">OTROS TRÁFICOS</th>
                        <th style="width:15%; text-align: center;">TOTAL</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-row let-i="rowIndex">
                    <tr>
                        <td style="text-align: center;">{{row.codejecutivo}}</td>
                        <td>{{row.nombreejecutivo}}</td>
                        <td>
                            <input class="p-inputtext-sm" type="number" formControlName="'cuota_' + i" pInputText
                                (input)="onInputChange($event, i, 'cuota')" [value]="row.cuota" [min]="0"/>
                        </td>
                        <td>
                            <input class="p-inputtext-sm" type="number" formControlName="'exportaciones_' + i"
                                pInputText (input)="onInputChange($event, i, 'exportaciones')"
                                [value]="row.exportaciones" [min]="0"/>
                        </td>
                        <td>
                            <input class="p-inputtext-sm" type="number" formControlName="'oTraficos_' + i" pInputText
                                (input)="onInputChange($event, i, 'oTraficos')" [value]="row.oTraficos" [min]="0"/>
                        </td>
                        <td>
                            <input class="p-inputtext-sm" type="number" formControlName="'total_' + i" pInputText [min]="0"
                                [readOnly]="true" (input)="onInputChange($event, i, 'total')" [value]="row.total" />
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </form>
    </div>
</p-dialog>
<p-dialog header="" [(visible)]="visibleImport" [style]="{width: '90vw',height: '90vh'}" appendTo="body">
    <br>
    <div fxLayoutGap="20px" class="a-w1" style="display: flex; justify-content: center;">
        <input type="file" (change)="onFileChange($event)" id="fileInput" style="display: none" />
        <p-button icon="pi pi-file-excel" label="Cargar Excel" severity="info" (onClick)="selectFile()"></p-button>
        <p-button icon="pi pi-save" label="Guardar Excel" severity="info" (onClick)="guardarExcel()"></p-button>
        <p-button icon="pi pi-sign-out" label="Salir" severity="info" (onClick)="salirImportar()"></p-button>
        <!-- <button mat-raised-button class="button1" (click)="selectFile()">Cargar Excel</button> -->
        <!-- <button mat-raised-button class="button1" (click)="guardarExcel()">Guardar Excel</button>
        <button mat-raised-button class="button1" (click)="salirImportar()">Salir</button> -->
    </div>
    <div style="padding-top: 30px;">
        <app-datatable [dataTable]="dataTableImpo" [metadataTable]="cuotaEjecutivoImpo" [scrollHeight]="'600px'"></app-datatable>
    </div>
</p-dialog>